import React from "react";

export default function Web_NPM() {
  return (
    <div>
      <h1>What is npm</h1>
      <p>
        Route: <code>/web/npm</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
